module.exports = "/cyber/_next/static/images/pubgTabletBanner-07427c12a6554a9f399942ff6222fa24.jpg";